import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const LoginValueContext = createContext<typeof initialState>(initialState);

const LoginActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { LoginActionContext, LoginValueContext };
